import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Pie, Bar } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

export default function CampaignAnalytics() {
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    fetch("http://localhost/thedaltech/analytics_reports.php") // ✅ API endpoint
      .then((res) => res.json())
      .then((data) => setAnalytics(data))
      .catch((err) => console.error(err));
  }, []);

  if (!analytics) return <p className="p-6">Loading analytics...</p>;

  const { stats, clicksOverTime } = analytics;

  const bounceRate = {
    labels: ["Bounced", "Delivered"],
    datasets: [
      {
        data: [stats.bounced, stats.delivered],
        backgroundColor: ["#EF4444", "#10B981"],
      },
    ],
  };

  const unsubscribeRate = {
    labels: ["Unsubscribed", "Active"],
    datasets: [
      {
        data: [stats.unsubscribed, stats.active],
        backgroundColor: ["#F59E0B", "#3B82F6"],
      },
    ],
  };

  const clicksData = {
    labels: clicksOverTime.map((d) => d.day),
    datasets: [
      {
        label: "Clicks",
        data: clicksOverTime.map((d) => d.clicks),
        backgroundColor: "#6366F1",
      },
    ],
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow space-y-6">
      <h2 className="text-2xl font-bold">Campaign Analytics</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Bounce Rate</h3>
          <Pie data={bounceRate} />
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Unsubscribe Rate</h3>
          <Pie data={unsubscribeRate} />
        </div>
      </div>
      <div className="bg-white p-4 rounded shadow">
        <h3 className="font-semibold mb-2">Clicks Over Time</h3>
        <Bar data={clicksData} />
      </div>
    </div>
  );
}
